import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import type { WebhooksMessageAttempt } from '../../models/WebhooksMessageAttempt';

@Component({
  standalone: false,
  selector: 'odin-callback-transaction-modal',
  styleUrls: ['./callback-transaction-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './callback-transaction-modal.component.html'
})
export class CallbackTransactionModalComponent {
  // Injected as a field: WebhooksMessageAttempt is an interface, so it must not
  // appear as a constructor parameter type (the JIT test compiler reads those at runtime).
  public readonly data = inject<WebhooksMessageAttempt>(MAT_DIALOG_DATA);


  copyCallbackResponse() {
    navigator.clipboard.writeText(this.data.response || '')
      .then(() => alert('Full response copied to clipboard!'))
      .catch(err => alert('Failed to copy response.'));
  }
}